import { useState } from 'react';
import s from './TermsModal.module.css';

const TermsModal = ({ isOpen, setIsOpen }) => {
    return (
        <div className={`${s.modal} ${isOpen ? s.open : s.close}`}>
            <div className={s.modalBackdrop}>
                <div className={s.modalContent} onClick={(e) => e.stopPropagation()}>
                    <h2>이용약관</h2>
                    <div className={s.termsText}>
                        <button style={{padding:10}} onClick={() => setIsOpen(false)}>약관 닫기</button>
                        <p><strong>제1조 (목적)</strong><br />
                            이 약관은 Seopia Cloud (이하 "서비스")가 제공하는 클라우드 기반 파일 공유 및 보관 서비스(이하 "서비스")의 이용과 관련하여, 이용자와 서비스 제공자 간의 권리·의무 및 책임사항 등을 규정함을 목적으로 합니다.</p>

                        <p><strong>제2조 (용어의 정의)</strong><br />
                        <ol>
                            <li>"이용자"란 본 약관에 따라 서비스를 이용하는 회원 및 비회원을 말합니다.</li>
                            <li>"회원"이란 서비스에 가입하여 계정을 보유한 자를 말합니다.</li>
                            <li>"게시물"이란 이용자가 서비스에 업로드한 파일, 댓글, 텍스트 등을 포함한 일체의 콘텐츠를 말합니다.</li>
                            <li>"공용 클라우드"란 모든 이용자가 열람, 다운로드 가능한 영역을 말하며, "개인 클라우드"는 본인만 접근 가능한 파일 보관 공간을 의미합니다.</li>
                        </ol>
                        </p>

                        <p><strong>제3조 (약관의 효력 및 변경)</strong><br />
                        <ol>
                            <li>본 약관은 서비스 초기 화면 및 가입 시 동의를 통해 효력을 발생합니다.</li>
                            <li>서비스는 필요 시 관련 법령을 위반하지 않는 범위 내에서 약관을 개정할 수 있으며, 개정 시 사전 공지합니다.</li>
                            <li>변경된 약관에 동의하지 않을 경우 서비스 이용을 중단할 수 있으며, 계속 이용 시 개정에 동의한 것으로 간주합니다.</li>
                        </ol>
                        </p>

                        <p><strong>제4조 (서비스의 제공 및 중단)</strong><br />
                        <ol>
                            <li>서비스는 연중무휴, 1일 24시간 제공함을 원칙으로 합니다.</li>
                            <li>다음과 같은 경우 서비스 제공이 일시적으로 중단될 수 있습니다:</li>
                            <ul>
                                <li>시스템 점검 또는 서버 확장</li>
                                <li>천재지변, 해킹, 통신장애 등 불가항력 사유</li>
                                <li>서비스 운영상 기타 긴급한 필요</li>
                            </ul>
                        </ol>
                         </p>

                        <p><strong>제5조 (이용자의 의무)</strong><br />
                        이용자는 다음 행위를 하여서는 안 됩니다:
                        <ol>
                            <li>타인의 개인정보를 도용하거나 허위 정보를 등록하는 행위</li>
                            <li>음란물, 불법 복제물, 저작권을 침해하는 자료를 업로드하는 행위</li>
                            <li>악성 코드나 바이러스 포함 파일의 업로드</li>
                            <li>서비스를 상업적 용도로 무단 사용하는 행위</li>
                            <li>기타 대한민국 법령 및 공공질서에 위반되는 행위</li>
                        </ol> </p>

                            <p><strong>제6조 (게시물의 관리)</strong><br />
                            <ol>
                                <li>서비스는 이용자가 업로드한 게시물의 내용이 제5조를 위반하거나, 사회적 물의를 일으킬 경우 사전 통지 없이 해당 게시물을 삭제할 수 있습니다.</li>
                                <li>저작권 등 권리를 침해당한 자는 서비스 측에 삭제 요청을 할 수 있으며, 서비스는 관련 법령에 따라 이를 처리합니다.</li>
                            </ol></p>

                            <p><strong>제7조 (저작권)</strong><br />
                            <ol>
                                <li>이용자가 업로드한 게시물의 저작권은 해당 이용자에게 귀속됩니다.</li>
                                <li>다만, 이용자는 서비스 운영 및 홍보를 위해 비영리 목적의 범위 내에서 서비스 측이 게시물을 활용할 수 있음에 동의합니다.</li>
                            </ol></p>

                            <p><strong>제8조 (면책조항)</strong><br />
                            <ol>
                                <li>서비스는 이용자가 업로드한 콘텐츠에 대해 일체의 책임을 지지 않으며, 파일의 품질·적법성·신뢰성에 대해 보장하지 않습니다.</li>
                                <li>서비스는 이용자 간 분쟁 또는 제3자와의 법적 분쟁에 관여하지 않으며, 손해에 대해 책임지지 않습니다.</li>
                            </ol></p>

                            <p><strong>제9조 (개인정보 보호)</strong><br />
                                <ol>
                                    <li>서비스는 관련 법령에 따라 이용자의 개인정보를 보호하며, 개인정보 처리방침을 통해 그 내용을 고지합니다.</li>
                                    <li>이용자는 자신의 계정정보를 스스로 보호할 책임이 있으며, 타인과 공유하거나 유출해서는 안 됩니다.</li>
                                </ol></p>

                            <p><strong>제10조 (관할법원)</strong><br />
                                서비스와 이용자 간 발생한 분쟁은 대한민국 민사소송법에 따라 관할법원을 정합니다.</p>
                            <p><strong>부칙</strong><br/>
                            본 약관은 2025년 6월 12일부터 적용됩니다.</p>

                    </div>
                    <button style={{padding:10}} onClick={() => setIsOpen(false)}>약관 닫기</button>
                </div>
            </div>
        </div>
    );
};

export default TermsModal;